import { STORE_SUBSCRIPTION } from "../constants/constants";

export const subscriptionAction = (data) => {
  return {
    type: STORE_SUBSCRIPTION,
    payload: data,
  };
};
